<template>
  <v-dialog
    v-model="showDialog"
    :max-width="customerSubscriptions && customerSubscriptions.length > 0 ? 600 : 350"
  >
    <v-card>
      <v-card-title>
        {{ $t('Components.Dialogs.DeleteCustomer.Title') }}
        <v-spacer />
        <v-icon
          aria-label="Close"
          @click="closeDialog"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text
        v-if="customerToDelete"
        class="text-center"
      >
        {{ deleteCustomerMessage }}
      </v-card-text>
      <v-card-text
        class="text-center"
      >
        <v-data-table
          v-if="customerSubscriptions && customerSubscriptions.length > 0"
          dense
          :headers="headers"
          :items="customerSubscriptions"
          :disable-pagination="true"
          :hide-default-footer="true"
          :hide-default-header="true"
          :items-per-page="customerSubscriptions.length"
        >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th
                  v-for="(header, i) in headers"
                  :key="`header-${i}`"
                  class="text-center"
                >
                  {{ $t(header.text) }}
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ getProductNameByVariantId(item.productVariantId) }}</td>
              <td>{{ getProductVariantNameByVariantId(item.productVariantId) }}</td>
              <td>{{ item.createdDate | moment("DD/MM/YYYY HH:mm:ss") }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-text class="pb-6 pt-12 text-center">
        <v-btn
          class="mr-3"
          text
          @click.stop="closeDialog"
        >
          {{ $t('General.Buttons.Cancel') }}
        </v-btn>

        <debounce-v-btn
          v-if="!customerSubscriptions || customerSubscriptions.length == 0"
          color="error"
          text
          @click="deleteCustomer"
        >
          {{ $t('General.Buttons.Delete') }}
        </debounce-v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import subscriptionsService from '@/services/subscriptionsService'

  export default {
    name: 'DeleteCustomerDialog',
    props: {
      customerToDelete: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data: () => ({
      showDialog: false,
      customerSubscriptions: [],
      deleteCustomerMessage: '',
      headers: [
        {
          text: 'Components.Dialogs.DeleteCustomer.TableHeaders.Product',
          sortable: false,
          align: 'center',
          value: 'productVariantId',
        },
        {
          text: 'Components.Dialogs.DeleteCustomer.TableHeaders.Variant',
          sortable: false,
          align: 'center',
          value: 'productVariantId',
        },
        {
          text: 'Components.Dialogs.DeleteCustomer.TableHeaders.StartDate',
          sortable: false,
          align: 'center',
          value: 'createdDate',
        },
      ],
    }),
    computed: {
      ...mapGetters(['getProductNameByVariantId', 'getProductVariantNameByVariantId']),
    },
    watch: {
      customerToDelete: async function (customer) {
        if (customer) {
          var customerSubscriptionsApiResult = await subscriptionsService.getCustomerSubscriptions(this.customerToDelete.uid)
          if (customerSubscriptionsApiResult.success === false) {
            return
          }

          this.customerSubscriptions = customerSubscriptionsApiResult.value
          if (this.customerSubscriptions && this.customerSubscriptions.length > 0) {
            this.deleteCustomerMessage = this.$t('Components.Dialogs.DeleteCustomer.Messages.CustomerHasSubscriptions', [this.customerToDelete.name])
          } else {
            this.deleteCustomerMessage = this.$t('Components.Dialogs.DeleteCustomer.Messages.ConfirmDeleteCustomer', [this.customerToDelete.name])
          }
          this.showDialog = true
        }
      },
    },
    created: async function () {
      if (this.$store.state.products.list.length === 0) {
        await this.$store.dispatch('RefreshProducts')
      }
    },
    methods: {
      deleteCustomer () {
        this.$emit('deleteCustomer', this.customerToDelete)
        this.showDialog = false
      },
      closeDialog () {
        this.$emit('close', false)
        this.showDialog = false
      },
    },
  }
</script>
